import { render, staticRenderFns } from "./statisticalReport.vue?vue&type=template&id=2e9e8227&scoped=true"
import script from "./statisticalReport.vue?vue&type=script&lang=js"
export * from "./statisticalReport.vue?vue&type=script&lang=js"
import style0 from "./statisticalReport.vue?vue&type=style&index=0&id=2e9e8227&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9e8227",
  null
  
)

export default component.exports